import classNames from 'classnames';
import React, { useImperativeHandle, useRef } from 'react';
import { IChatTextMessage } from '@enuan/chat__utils';
import { BreakLine } from '../UI/BreakLine/BreakLine';
import { useBlockMessageClassNames } from 'src/hooks/core/messages.hooks';
import { useMessageContext } from '../message/message.context';
import { useMessageReadEffect } from 'src/hooks/useMessageReadEffect';
import type { IOptionalMessageProps } from '../UI/Message/Message';

export const InfoMessage = React.forwardRef<
	HTMLDivElement,
	{ className?: string } & IOptionalMessageProps
>(function InfoMessage({ className: classNameProp, ...props }, ref) {
	const { message } = useMessageContext<IChatTextMessage>();
	const messageClassName = useBlockMessageClassNames();

	const rootRef = useRef<HTMLDivElement>(null!);
	useImperativeHandle(ref, () => rootRef.current);
	useMessageReadEffect(rootRef, message);

	return (
		<BreakLine
			className={classNames(classNameProp, messageClassName, 'message--info')}
			{...props}
			ref={rootRef}
		>
			{message._data}
		</BreakLine>
	);
});
